module.exports = __webpack_public_path__ + "img/logo_panni.7d7b6253.png";